import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import PrimaryCheckbox from "../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";

export default function SelectedFilter({
  setSelectAll,
  data
}) {
  const [checked, setChecked] = useState(false);

  const handleChecked = (e) => {
    setChecked(e.target.checked);
    setSelectAll(e.target.checked);
  };

  useEffect(() => {
    if (data.length > 0) {
      if (data.some(({ selected }) => !selected)) {
        setChecked(false);
      } else if (data.every(({ selected }) => selected)) {
        setChecked(true);
      }
    }
  }, [data]);

  return (
    <Box sx={{ marginRight: "9px" }}>
      <PrimaryCheckbox
        checked={checked}
        handleChange={e => handleChecked(e)}
      />
    </Box>
  );
}

SelectedFilter.propTypes = {
  setSelectAll: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired
};